import { css as _css } from "@emotion/react";
import { su, theme } from '@arc/frontend/ui-theme';
export function SectionDividerLine() {
  return <span css={/*#__PURE__*/_css({
    backgroundColor: theme.colors.input.border,
    height: '1px'
  }, process.env.NODE_ENV === "production" ? "" : ";label:SectionDividerLine;")} />;
}
export function SectionDivider({
  text
}) {
  return <div css={/*#__PURE__*/_css({
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: text ? '1fr auto 1fr' : '1fr',
    minHeight: su.textXs.lineHeight
  }, process.env.NODE_ENV === "production" ? "" : ";label:SectionDivider;")}>
			<SectionDividerLine />
			{text ? <>
					<div css={[su.textXs, {
        color: theme.colors.text.secondary,
        margin: '0 0.75rem'
      }, process.env.NODE_ENV === "production" ? "" : ";label:SectionDivider;"]}>
						{text}
					</div>
					<SectionDividerLine />
				</> : null}
		</div>;
}